var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcListTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 8.25H11.75M4.25 8.25H4.625M4.25 5.625H4.625M4.25 10.875H4.625M6.875 10.875H11.75M11.75 5.625H6.875M14.75 8.25V4.7775C14.75 3.88275 14.75 3.435 14.6315 3.075C14.5239 2.74068 14.3406 2.43567 14.0959 2.18371C13.8513 1.93175 13.5518 1.73962 13.2208 1.62225C12.8698 1.5 12.4355 1.5 11.5662 1.5H4.43375C3.5645 1.5 3.13025 1.5 2.77925 1.62225C2.44833 1.73959 2.14892 1.93163 1.90425 2.18345C1.65959 2.43527 1.47626 2.74009 1.3685 3.07425C1.25 3.43575 1.25 3.88275 1.25 4.7775L1.25 14.25L1.25 15.2805C1.25 15.924 1.98875 16.266 2.456 15.8385C2.58709 15.7174 2.75902 15.6501 2.9375 15.6501C3.11598 15.6501 3.28791 15.7174 3.419 15.8385L3.78125 16.17C4.01091 16.3824 4.3122 16.5003 4.625 16.5003C4.9378 16.5003 5.23909 16.3824 5.46875 16.17C5.69841 15.9576 5.9997 15.8397 6.3125 15.8397C6.6253 15.8397 6.92659 15.9576 7.15625 16.17C7.38591 16.3824 7.6872 16.5003 8 16.5003C8.3128 16.5003 8.61409 16.3824 8.84375 16.17C9.07341 15.9576 9.3747 15.8397 9.6875 15.8397C10.0003 15.8397 10.3016 15.9576 10.5312 16.17C10.7609 16.3824 11.0622 16.5003 11.375 16.5003C11.6878 16.5003 11.9891 16.3824 12.2188 16.17L12.581 15.8385C12.7121 15.7174 12.884 15.6501 13.0625 15.6501C13.241 15.6501 13.4129 15.7174 13.544 15.8385C14.0113 16.266 14.75 15.924 14.75 15.2805V8.25Z",
    stroke: "#435869",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListTicket);
export default __webpack_public_path__ + "static/media/icListTicket.c5d001fad8b8c77900daff103109cec4.svg";
export { ForwardRef as ReactComponent };